import React, { useRef, useEffect, useState } from 'react';
import './App.css';
import Navbar from './components/Navbar/Navbar';
import About from './components/About/About';
import TechStack from './components/TechStack/TechStack';
import Experience from './components/Experience/Experience';
import Projects from './components/Projects/Projects'; 
import Footer from './components/footer/footer'; 
import Specializing from './components/specializing/spec';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import IconCloud from './components/IconCloud';
import {Loader} from "./components/Loader"
import { ThemeProvider } from './components/ThemeContext'; 

export default function AppWithProvider() {
  const [showMainApp, setShowMainApp] = useState(false);
  const aboutRef = useRef(null);
  const techStackRef = useRef(null);
  const experienceRef = useRef(null);
  const projectsRef = useRef(null);
  const footerRef = useRef(null);

  useEffect(() => {
    const timer = setTimeout(() => {
      setShowMainApp(true);
    }, 3000); // Adjust the duration as needed

    return () => clearTimeout(timer);
  }, []);

  const scrollToSection = (ref) => {
    if (ref.current) {
      ref.current.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <ThemeProvider>
    <div className="App">
      {showMainApp ? (
        <BrowserRouter>
          <Navbar scrollToSection={{
            about: () => scrollToSection(aboutRef),
            techStack: () => scrollToSection(techStackRef),
            experience: () => scrollToSection(experienceRef),
            projects: () => scrollToSection(projectsRef),
            footer: () => scrollToSection(footerRef),
          }} />
          <Routes>
            <Route path="/" element={
              <>
                <About ref={aboutRef} />
                <TechStack ref={techStackRef} />
                <Specializing />
                <Experience ref={experienceRef} />
                <Projects ref={projectsRef} />
                <Footer ref={footerRef} />
              </>
            } />
          </Routes>
        </BrowserRouter>
      ) : (
        <Loader/>
      )}
    </div></ThemeProvider>
  );
}
